<template>
	<b-modal
		ref="padrillos-madrillas-by-death-reason-modal"
		:title="`Motivo de muerte | ${selectedReason.reason || 'Sin motivo'} : ${selectedReason.qty || 0}`"
		no-close-on-backdrop
		centered
		@hidden="handleHidden"
		size="xmd"
		hide-footer
	>
		<div>
			<b-row>
				<b-col>
					<h5 class="font-weight-bolder text-primary my-1">
						Total de padrillos: {{ padrilloPagination.total }}
					</h5>
					<div style="max-height: 60vh; overflow-y: auto" @scroll="handlePadrilloScroll">
						<b-table-simple responsive no-border-collapse>
							<b-thead class="sticky-header" style="white-space: nowrap">
								<b-th class="text-center">Padrillo</b-th>
								<b-th class="text-center">Cantidad</b-th>
							</b-thead>
							<b-tbody>
								<template v-if="padrilloRows.length > 0">
									<b-tr v-for="(row, index) in padrilloRows" :key="index">
										<b-td class="text-center">
											<SpecimenPlate :specimen="row.padrillo" />
										</b-td>

										<b-td
											class="text-primary underline-hover text-center"
											@click="openPosturesByPadrillo(row)"
										>
											<span>{{ row.qty }}</span>
										</b-td>
									</b-tr>
								</template>
								<b-tr v-if="padrilloRows.length === 0">
									<b-td colspan="10" class="text-center" style="height: 80px">
										No hay posturas para mostrar
									</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</div>
				</b-col>
				<b-col>
					<div class="font-weight-bolder text-primary my-1">
						Total de madrillas: {{ madrillaPagination.total }}
					</div>
					<div style="max-height: 60vh; overflow-y: auto" @scroll="handleMadrillaScroll">
						<b-table-simple responsive no-border-collapse>
							<b-thead class="sticky-header" style="white-space: nowrap">
								<b-th class="text-center">Madrilla</b-th>
								<b-th class="text-center">Cantidad</b-th>
							</b-thead>
							<b-tbody>
								<template v-if="madrillaRows.length > 0">
									<b-tr v-for="(row, index) in madrillaRows" :key="index">
										<b-td class="text-center">
											<SpecimenPlate :specimen="row.madrilla" />
										</b-td>

										<b-td
											class="text-primary underline-hover text-center"
											@click="openPosturesByMadrilla(row)"
										>
											<span>{{ row.qty }}</span>
										</b-td>
									</b-tr>
								</template>
								<b-tr v-if="madrillaRows.length === 0">
									<b-td colspan="10" class="text-center" style="height: 80px">
										No hay posturas para mostrar
									</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</div>
				</b-col>
			</b-row>
		</div>
		<PosturesByDeathReasonModal
			v-if="showPosturesByDeathReason"
			:start_date="start_date"
			:end_date="end_date"
			:selectedReason="selectedReason"
			:lote_id="lote_id"
			:selectedPadrillo="selectedPadrillo"
			:selectedMadrilla="selectedMadrilla"
			@closing="showPosturesByDeathReason = false"
		/>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import lotesService from "@/services/lotes.service"
import PosturesByDeathReasonModal from "@/views/amg/encaste/lotes/modals/death_reasons/PosturesByDeathReasonModal.vue"
export default {
	components: { SpecimenPlate, PosturesByDeathReasonModal },
	props: {
		start_date: String,
		end_date: String,
		selectedReason: Object,
		lote_id: Number,
	},
	data() {
		return {
			showPosturesByDeathReason: false,
			madrillasIsLoading: false,
			padrillosIsLoading: false,
			madrillaRows: [],
			padrilloRows: [],
			selectedPadrillo: null,
			selectedMadrilla: null,
			madrillaPagination: {
				total: 0,
				curPage: 0,
				perPage: 10,
				from: 0,
				to: 0,
			},
			padrilloPagination: {
				total: 0,
				curPage: 0,
				perPage: 10,
				from: 0,
				to: 0,
			},
		}
	},
	methods: {
		openPosturesByPadrillo(row) {
			this.selectedPadrillo = { ...row.padrillo, qty: row.qty }
			this.selectedMadrilla = null
			this.showPosturesByDeathReason = true
		},
		openPosturesByMadrilla(row) {
			this.selectedMadrilla = { ...row.madrilla, qty: row.qty }
			this.selectedPadrillo = null
			this.showPosturesByDeathReason = true
		},
		async handleMadrillaScroll(event) {
			const { scrollTop, scrollHeight, clientHeight } = event.target
			if (scrollTop + clientHeight >= scrollHeight - 10) {
				await this.loadMoreMadrillaData()
			}
		},
		async loadMoreMadrillaData() {
			if (
				this.madrillasIsLoading ||
				(this.madrillaPagination.curPage > 0 &&
					this.madrillaPagination.curPage * this.madrillaPagination.perPage >= this.madrillaPagination.total)
			) {
				return
			}
			this.madrillasIsLoading = true
			this.madrillaPagination.curPage += 1
			try {
				const { data } = await lotesService.getMadrillasByDeathReasonsDetail({
					per_page: this.madrillaPagination.perPage,
					page: this.madrillaPagination.curPage,
					start_date: this.lote_id ? null : this.start_date,
					end_date: this.lote_id ? null : this.end_date,
					reason_id: this.selectedReason.reason_id,
					lote_id: this.lote_id,
					is_total: this.selectedReason.is_total,
				})
				this.madrillaRows = [...this.madrillaRows, ...data.data]
				this.madrillaPagination.total = data.total
			} catch (error) {
				console.log(error)
			} finally {
				this.madrillasIsLoading = false
			}
		},
		async handlePadrilloScroll(event) {
			const { scrollTop, scrollHeight, clientHeight } = event.target
			if (scrollTop + clientHeight >= scrollHeight - 10) {
				await this.loadMorePadrilloData()
			}
		},
		async loadMorePadrilloData() {
			if (
				this.padrillosIsLoading ||
				(this.padrilloPagination.curPage > 0 &&
					this.padrilloPagination.curPage * this.padrilloPagination.perPage >= this.padrilloPagination.total)
			) {
				return
			}
			this.padrillosIsLoading = true
			this.padrilloPagination.curPage += 1
			try {
				const { data } = await lotesService.getPadrillosByDeathReasonsDetail({
					per_page: this.padrilloPagination.perPage,
					page: this.padrilloPagination.curPage,
					start_date: this.lote_id ? null : this.start_date,
					end_date: this.lote_id ? null : this.end_date,
					reason_id: this.selectedReason.reason_id,
					lote_id: this.lote_id,
					is_total: this.selectedReason.is_total,
				})
				this.padrilloRows = [...this.padrilloRows, ...data.data]
				this.padrilloPagination.total = data.total
			} catch (error) {
				console.log(error)
			} finally {
				this.padrillosIsLoading = false
			}
		},
		handleHidden() {
			this.madrillasIsLoading = false
			this.padrillosIsLoading = false
			this.$emit("closing")
		},
	},
	async mounted() {
		await Promise.all([this.loadMorePadrilloData(), this.loadMoreMadrillaData()])
		this.$refs["padrillos-madrillas-by-death-reason-modal"].toggle()
	},
}
</script>

<style>
.label-filter {
	font-size: 0.8rem;
}

.nav.nav-tabs {
	flex-wrap: nowrap;
	overflow-x: auto;
	padding-bottom: 0.5rem;
}

.nav-link {
	white-space: nowrap;
}
.scroll-container {
	max-height: 60vh;
	overflow-y: auto;
}
.underline-hover {
	text-decoration: underline;
	transition: all 0.1s ease;
}
.underline-hover:hover {
	font-weight: bold;
	cursor: pointer;
	font-size: 1.2rem;
}
</style>
